import {FC} from 'react';

import WordIcon from '../icons/WordIcon';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import PDFIcon from '../icons/PDFIcon';
import ExcelIcon from '../icons/ExcelIcon';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import JPGIcon from '../icons/JPGIcon';
import PNGIcon from '../icons/PNGIcon';

interface IDocIconSwitcher {
  docName: string;
  error?: boolean;
}

const DocIconSwitcher: FC<IDocIconSwitcher> = ({docName, error}) => {
  const splittedName = docName.split('.');
  const color = error ? 'error' : undefined;

  switch (splittedName[splittedName.length - 1]) {
    case 'doc':
      return <WordIcon />;
    case 'docx':
      return <WordIcon />;
    case 'xlsx':
      return <ExcelIcon />;
    case 'xls':
      return <ExcelIcon />;
    case 'pdf':
      return <PDFIcon />;
    case 'txt':
      return <TextSnippetOutlinedIcon />;
    case 'jpg':
      return <JPGIcon />;
    case 'jpeg':
      return <JPGIcon />;
    case 'png':
      return <PNGIcon />;
    default:
      return <InsertDriveFileOutlinedIcon color={color} />;
  }
};

export default DocIconSwitcher;
